function mhReplace(){
    $('.products').each(function(){
        $(this).find('a.btn.btn-primary').text('Více')
    })

    if($('.type-category').length){
        var url = window.location.pathname;

    // Hledání odpovídajících produktů pro aktuální URL
    var matchedProducts = [];
    var otherProducts = [];

    $.each(customCategory, function(index, category) {
        if (url === category.url) {
            matchedProducts = category.productsLines;
            return false; // Ukončíme smyčku, protože jsme našli shodu
        }
    });

    var url = window.location.pathname;

    // Hledání odpovídajících produktů pro aktuální URL
    var matchedProducts = [];
    var otherProducts = [];

    $.each(customCategory, function(index, category) {
        if (url === category.url) {
            matchedProducts = category.productsLines;
            return false; // Ukončíme smyčku, protože jsme našli shodu
        }
    });

    // Projdeme každou položku line v matchedProducts
    $.each(matchedProducts, function(index, productLine) {
        $('body').addClass('haveCustomProduct')
        var lineName = productLine.LineName;
        var lineCodes = productLine.lineCodes.split(';');
        var lineImage = productLine.lineImage ? '<img src="' + productLine.lineImage + '" alt="' + lineName + '">' : '';
        var $lineContainer = $('<div id="products" class="customProductLine products products-page products-block"><div class="product titleLine"><div class="p"><h2>' + lineName + '</h2>'+lineImage +'</div></div></div>');
        // Projdeme všechny lineCodes a najdeme odpovídající produkty
        $.each(lineCodes, function(index, sku) {
            // Najdeme všechny produkty se shodným SKU
            var $matchingProducts = $('.category-content-wrapper .product').filter(function() {
                return $(this).find('span[data-micro="sku"]').text() === sku;
            });

            // Přidáme nalezené produkty do kontejneru
            $matchingProducts.each(function() {
                $lineContainer.append($(this));
            });
        });

        // Pokud v LineName nejsou žádné produkty, nevkládáme ho
        if ($lineContainer.children().length > 1) {
            $('#products').before($lineContainer);
        }
    });
    }
}


$(document).ready(function() {
    mhReplace();
    sliderProducts();
    $('.haveCustomProduct .products:not(.customProductLine)').each(function(){
        if(!$(this).find('.product').length){
            $(this).hide()
        }
    })
  })
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhReplace();
    sliderProducts();
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    mhReplace();
    sliderProducts();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    mhReplace();
    sliderProducts();

});